export const GREATEST_HITS_TAG_NAME = 'badge-hero';
